"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSockets = void 0;
const baseAsyncXhr_1 = require("../baseAsyncXhr");
class WebSockets extends baseAsyncXhr_1.BaseAsyncXhr {
    constructor(eventsManager) {
        super(eventsManager);
    }
    doConnect(connectionParams) {
        return new Promise(resolve => {
            this.ws = new WebSocket(connectionParams.url);
            this.ws.onopen = (connectData) => {
                this.eventsManager.notifyConnect();
                resolve();
            };
            this.ws.onclose = (event) => __awaiter(this, void 0, void 0, function* () {
                this.eventsManager.notifyDisconnect();
            });
            this.listen(this.eventsManager.onDataReceive, this.eventsManager.notifyConnectionError);
        });
    }
    doDisconnect(event) {
        return new Promise(resolve => {
            this.ws.close(event);
            resolve();
        });
    }
    sendData(data) {
        this.ws.send(data);
    }
    sendDataAndWait(data) {
        return new Promise((resolve, reject) => {
            this.listen(resolve, reject);
            this.ws.send(data);
        });
    }
    listen(onSuccess, onError) {
        this.ws.onmessage = (message) => {
            onSuccess(message.data);
        };
        this.ws.onerror = (error) => {
            onError === null || onError === void 0 ? void 0 : onError(error);
        };
    }
}
exports.WebSockets = WebSockets;
//# sourceMappingURL=index.js.map